export default __webpack_public_path__ + "static/media/videobg.b88e8a78.mp4";